import { render, staticRenderFns } from "./BudgetReportDetails.vue?vue&type=template&id=93d6df0a&scoped=true&"
import script from "./BudgetReportDetails.vue?vue&type=script&lang=js&"
export * from "./BudgetReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./BudgetReportDetails.vue?vue&type=style&index=0&id=93d6df0a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d6df0a",
  null
  
)

export default component.exports